/**
 * Bundled / known SoundFont catalog. Custom project fonts can extend this later.
 */

export type Sf2FontEntry = {
  id: string;
  name: string;
  /** Lab-relative URL (served from apps/audio-lab/assets). */
  url: string;
  /** Default MIDI bank when selecting this font in the UI. */
  defaultBank?: number;
  /** Default program when selecting this font in the UI. */
  defaultProgram?: number;
};

export const SF2_FONT_CATALOG: readonly Sf2FontEntry[] = [
  {
    id: "upright-piano-kw",
    name: "Upright Piano KW",
    url: "/assets/soundfonts/UprightPianoKW.sf2",
    defaultBank: 0,
    defaultProgram: 0,
  },
  {
    id: "electric-guitar",
    name: "Electric Guitar",
    url: "/assets/soundfonts/ElectricGuitar.SF2",
    defaultBank: 0,
    defaultProgram: 0,
  },
  {
    id: "distortion-guitar",
    name: "Distortion Guitar",
    url: "/assets/soundfonts/DistortionGuitar.SF2",
    /** Font ships presets on bank 126 (Distorted / Clean / Chords / Bass). */
    defaultBank: 126,
    defaultProgram: 0,
  },
  {
    id: "tama-rockstar",
    name: "Tama RockSTAR",
    url: "/assets/soundfonts/TamaRockSTAR.sf2",
    /** SF2 percussion bank (GM drum map). */
    defaultBank: 128,
    defaultProgram: 0,
  },
] as const;

/** Default melodic SoundFont (piano). */
export const DEFAULT_SF2_FONT_ID = "upright-piano-kw";

/** Clean / acoustic-ish electric guitar SoundFont. */
export const ELECTRIC_GUITAR_SF2_FONT_ID = "electric-guitar";

/** Overdriven / distortion guitar SoundFont. */
export const DISTORTION_GUITAR_SF2_FONT_ID = "distortion-guitar";

/** Default drum SoundFont (GM percussion kit). */
export const DEFAULT_DRUM_SF2_FONT_ID = "tama-rockstar";

export function findSf2Font(fontId: string): Sf2FontEntry | undefined {
  return SF2_FONT_CATALOG.find(entry => entry.id === fontId);
}

export function sf2FontDisplayName(fontId: string): string {
  return findSf2Font(fontId)?.name ?? fontId;
}

/** True when this font is the drum kit (or any SF2 percussion bank 128 patch). */
export function isDrumSf2Font(fontId: string): boolean {
  return fontId === DEFAULT_DRUM_SF2_FONT_ID;
}
